(function ()
{
    var root = document.getElementById('aumex-hotspots');

    if (!root)
        return;

    var overlays = Array.prototype.slice.call(root.querySelectorAll('picture.overlay img'));
    var hotspots = Array.prototype.slice.call(root.querySelectorAll('.hotspot'));

    // Guard to decouple quick successive events (e.g., focus -> click on mobile)
    var CLICK_GUARD_MS = 120; // ~100ms as requested, with small headroom
    var HIDE_DELAY_MS = 333; // requested 333ms delay before hide
    var lastHoverFocusAt = 0;
    var lastClickAt = 0;
    var hideTimer = null;

    function nowMs()
    {
        return (window.performance && performance.now)
            ? performance.now()
            : Date.now();
    }

    var activeId = null;

    function isMobile()
    {
        return window.innerWidth <= 576;
    }

    function clampLabel(hotspotEl)
    {
        var label = hotspotEl.querySelector('.label');

        if (!label)
            return;

        if (!isMobile())
        {
            // Desktop: reset any previous inline left and let CSS handle it
            label.style.left      = '';
            label.style.transform = '';
            return;
        }

        // Reset to CSS default first so offsetWidth reflects unwrapped size
        label.style.left      = '';
        label.style.transform = '';

        var labelW   = label.offsetWidth;
        var contRect = root.getBoundingClientRect(); // #aumex-hotspots bounding box
        var hotRect  = hotspotEl.getBoundingClientRect();
        var pad      = 8; // px gap from viewport edge

        // Where the label centre would be (same as hotspot centre)
        var hotCx = hotRect.left + hotRect.width / 2;

        // Ideal left edge if centred on hotspot
        var idealLeft  = hotCx - labelW / 2;
        var idealRight = idealLeft + labelW;
        var vw         = window.innerWidth || document.documentElement.clientWidth;

        // Clamp within viewport
        var clampedLeft = idealLeft;

        if (idealLeft < pad)
            clampedLeft = pad;
        else if (idealRight > vw - pad)
            clampedLeft = vw - pad - labelW;

        // Convert back to a position relative to the hotspot element
        // (label is absolute inside .hotspot, so we need offset from hotspot's left edge)
        var hotLeft = hotRect.left; // hotspot left edge in viewport coords

        label.style.left      = (clampedLeft - hotLeft) + 'px';
        label.style.transform = 'none'; // override translateX(-50%) from CSS
    }

    function clampActiveLabel()
    {
        if (activeId === null)
            return;

        hotspots.forEach(function (b)
        {
            if (b.dataset.hotspot === activeId)
                clampLabel(b);
        });
    }

    function show(id)
    {
        activeId = id;

        overlays.forEach(function (o)
        {
            if (o.dataset.hotspot === id)
                o.parentNode.classList.add('is-visible');
            else
                o.parentNode.classList.remove('is-visible');
        });

        hotspots.forEach(function (b)
        {
            b.classList.toggle('is-active', b.dataset.hotspot === id);
        });

        // Clamp the label of the newly active hotspot into the viewport
        hotspots.forEach(function (b)
        {
            if (b.dataset.hotspot === id)
                clampLabel(b);
        });
    }

    function clear()
    {
        activeId = null;

        overlays.forEach(function (o)
        {
            o.parentNode.classList.remove('is-visible');
        });
        hotspots.forEach(function (b)
        {
            b.classList.remove('is-active');

            // Reset any inline left/transform set by clampLabel
            var label = b.querySelector('.label');

            if (label)
            {
                label.style.left      = '';
                label.style.transform = '';
            }
        });
    }

    function scheduleClear()
    {
        cancelScheduledClear();

        hideTimer = setTimeout(function ()
        {
            clear();
        }, HIDE_DELAY_MS);
    }

    function cancelScheduledClear()
    {
        if (hideTimer)
        {
            clearTimeout(hideTimer);
            
            hideTimer = null;
        }
    }

    // Pointer interactions
    hotspots.forEach(function (wrapper)
    {
        var id = wrapper.dataset.hotspot;
        var trigger = wrapper.querySelector('.hotspot-trigger');
        var label = wrapper.querySelector('.label');

        // Fallback if structure unexpected
        if (!trigger)
            trigger = wrapper;

        function pointerEnter()
        {
            cancelScheduledClear();
            show(id);

            lastHoverFocusAt = nowMs();
        }
        function pointerLeave(e)
        {
            // If moving into trigger or label, ignore
            var related = e.relatedTarget;

            if (related && (wrapper.contains(related)))
                return;

            scheduleClear();
        }

        // Enter events
        wrapper.addEventListener('mouseenter', pointerEnter);
        wrapper.addEventListener('focusin', pointerEnter);
        // Leave events with delay
        wrapper.addEventListener('mouseleave', pointerLeave);
        wrapper.addEventListener('focusout', function (e)
        {
            // If focus moves within wrapper, ignore
            if (wrapper.contains(e.relatedTarget))
                return;

            scheduleClear();
        });

        // Click to toggle immediate
        trigger.addEventListener('click', function ()
        {
            var t = nowMs();

            if ((t - lastHoverFocusAt) < CLICK_GUARD_MS || (t - lastClickAt) < CLICK_GUARD_MS)
                return;

            lastClickAt = t;

            if (wrapper.classList.contains('is-active'))
                clear();
            else
                show(id);
        });

        // Ensure label keeps hotspot visible while hovered
        if (label)
        {
            label.addEventListener('mouseenter', pointerEnter);
            label.addEventListener('mouseleave', pointerLeave);
        }
    });

    // Leaving entire root schedules clear
    root.addEventListener('mouseleave', function (e)
    {
        var related = e.relatedTarget;

        if (related && root.contains(related))
            return;

        scheduleClear();
    });

    document.addEventListener('click', function (e)
    {
        if (!root.contains(e.target))
            clear();
    });

    // Recalculate label position on resize (e.g. orientation change on mobile)
    window.addEventListener('resize', function ()
    {
        clampActiveLabel();
    });
})();